module.exports = __webpack_public_path__ + "static/mic.cc444542.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/mic.svg
// module id = 235
// module chunks = 35783957827783 95715928098905 172322841747965